import { ClientLogRequest } from '@1po/1po-bff-fe-spec/generated/client_log/request/ClientLogRequest';
import { PUT_CLIENT_LOG } from '@1po/1po-bff-fe-spec/generated/common/WebsocketConstants';
import { createAction } from '@reduxjs/toolkit';

// Saga actions
export const putClientLogSaga = createAction<{
  clientLogRequest: ClientLogRequest;
}>(PUT_CLIENT_LOG);
